import { render, staticRenderFns } from "./Variations.vue?vue&type=template&id=15e16b73&scoped=true&"
import script from "./Variations.vue?vue&type=script&lang=js&"
export * from "./Variations.vue?vue&type=script&lang=js&"
import style0 from "./Variations.vue?vue&type=style&index=0&id=15e16b73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e16b73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VCol,VRow,VSelect})
